import { render, staticRenderFns } from "./BaselineProductTabs.vue?vue&type=template&id=6efa578e&scoped=true"
import script from "./BaselineProductTabs.vue?vue&type=script&lang=js"
export * from "./BaselineProductTabs.vue?vue&type=script&lang=js"
import style0 from "./BaselineProductTabs.vue?vue&type=style&index=0&id=6efa578e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa578e",
  null
  
)

export default component.exports